import { useEffect } from 'react';

/**
 * Reveals every `.reveal` element once it scrolls into view by adding
 * `.is-visible`. Re-runs on mount only — new nodes rendered later (e.g. when a
 * tab switches) are handled because the observer is attached per element and
 * the effect also fires a fallback pass for anything already on screen.
 */
const useReveal = () => {
  useEffect(() => {
    const nodes = document.querySelectorAll('.reveal:not(.is-visible)');
    if (!nodes.length) return undefined;

    if (!('IntersectionObserver' in window)) {
      nodes.forEach((node) => node.classList.add('is-visible'));
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
    );

    nodes.forEach((node) => observer.observe(node));
    return () => observer.disconnect();
  }, []);
};

export default useReveal;
